

import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticateService } from 'app/services/authenticate.service';
import { AlertService } from 'app/services/alert.service';
import { MessageService } from 'app/services/message.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {

  model: any = {};
  loading = false;
  returnUrl: string;
  error = '';
  loading2: boolean;

  constructor(private route: ActivatedRoute,
    private router: Router, private authenticateService: AuthenticateService, private alertService: AlertService,private Message: MessageService) {
    this.authenticateService.logout();
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }

  ngOnInit() {
  } 

  login() {
              this.loading = true;
              this.authenticateService.login(this.model.username, this.model.password)
              .subscribe(
                  data => {
                    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
                    //this.router.navigate(["/expedientes/1/"+currentUser.conv_defecto]);
                    this.router.navigate(["/expedientes/1/0"]);
                      localStorage.setItem('isLoggedin', 'true');

                  },
                  error => {
                      alert('Usuario o clave desconocida');
                      this.alertService.error('Username or password is incorrect');
                      localStorage.setItem('isLoggedin', 'false');
                      this.loading = false;
                  });

          }


          register() {
            this.loading2 = true;
            this.authenticateService.register(this.model.email_reg)
            .subscribe(
                data => {
                  this.Message.addSuccess(` Correo electrónico enviado correctamente`)
                  this.loading2 = false;
                  this.model.email_reg=""
                },
                error => {
                  this.Message.addWarning(` No se ha recibido ninguna solicitud de acreditación para este solicitante, o no ha sido procesada.`)
                    this.loading2 = false;
                    this.model.email_reg="";
                });

        }


        }
        


// WEBPACK FOOTER //
// /app/src/app/modules/login/login.component.ts